import * as searchActions from "./constants";

export const SetSearchData = (data) => {
  return {
    type: searchActions.SET_SEARCH_ITEMS,
    payload: data,
  };
};
